/**
 * @fileoverview Erro ao salvar ou ativar um fluxo. O conflito (o template
 * inicial já abre outro fluxo ativo na conexão) vem com o nome do outro fluxo
 * e vira um aviso traduzido com o nome; o resto segue o toastError de sempre.
 */

import { toast } from "react-toastify";

import toastError from "../../errors/toastError";
import { translateWithLiterals } from "../../utils/translateWithLiterals";

export const showSaveError = (err) => {
  const data = err?.response?.data;
  if (data?.error === "ERR_SMART_APPROACH_TEMPLATE_IN_USE") {
    toast.error(translateWithLiterals("smartApproaches.conflict", { name: data.flowName || "" }));
    return;
  }
  toastError(err);
};
